import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { AssetResourceType } from '../../../interfaces';
import { Button, RadioButton } from '../../../subkit-ui';
import { getPriceStringInterval } from '../../../utils/helpers';
import { useDeviceInfo } from '../../../hooks/useDeviceInfo';
import { Separator } from '../../Separator';
import { Modal } from '../../Modal';
import TWSubscriptionPlan, { TWSubscriptionPlanCardType } from '../../TWSubscriptionPlan';
import { useSignupProvider } from '../../../hooks/useSignupProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

var PlanOptionItem = function PlanOptionItem(props) {
  var optionId = props.optionId,
      name = props.name,
      price = props.price,
      plan = props.plan,
      checked = props.checked,
      showSeparator = props.showSeparator,
      onChange = props.onChange,
      setShowModal = props.setShowModal,
      setCurrentPlan = props.setCurrentPlan;

  var onDetailsClick = function onDetailsClick(event) {
    event.preventDefault();
    onChange({
      isChecked: true,
      value: optionId
    });
    setCurrentPlan(plan);
    setShowModal(true);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex mb-0",
      children: [/*#__PURE__*/_jsx(RadioButton, {
        name: "payment-option",
        id: optionId,
        onChange: onChange,
        checked: checked,
        value: optionId
      }), /*#__PURE__*/_jsxs("div", {
        className: "ml-2 w-full -mt-0.5",
        children: [/*#__PURE__*/_jsx("p", {
          className: "flex my-0 text-lg font-semibold",
          children: name
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex justify-between font-medium text-base",
          children: [/*#__PURE__*/_jsx("p", {
            className: "flex my-0",
            children: getPriceStringInterval(price)
          }), /*#__PURE__*/_jsx("p", {
            className: "flex my-0 text-subkit-primary cursor-pointer",
            onClick: onDetailsClick,
            children: "Details"
          })]
        }), props.children]
      })]
    }), showSeparator && /*#__PURE__*/_jsx(Separator, {
      classNames: "my-4"
    })]
  });
};

export var TWPaymentOptions = function TWPaymentOptions(_ref) {
  var session = _ref.session,
      availablePlans = _ref.availablePlans,
      createSubscriptionOrder = _ref.createSubscriptionOrder,
      createSessionOrder = _ref.createSessionOrder,
      currentUser = _ref.currentUser;

  var _useSignupProvider = useSignupProvider(),
      doSignup = _useSignupProvider.doSignup;

  var _useState = useState(null),
      paymentOption = _useState[0],
      setPaymentOption = _useState[1];

  var _useState2 = useState(false),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = useState(null),
      selectedPlan = _useState3[0],
      setSelectedPlan = _useState3[1];

  var _useDeviceInfo = useDeviceInfo(),
      desktop = _useDeviceInfo.desktop,
      mobile = _useDeviceInfo.mobile,
      iPad = _useDeviceInfo.iPad;

  var handleOptionChange = function handleOptionChange(_ref2) {
    var isChecked = _ref2.isChecked,
        value = _ref2.value;
    if (!isChecked) return;
    setPaymentOption(value);
  };

  var checkoutAvailable = function checkoutAvailable() {
    var search = new URLSearchParams(window.location.search);
    var checkout = search.get('checkout');
    return !!currentUser && checkout;
  };

  useEffect(function () {
    if (availablePlans.length > 0) {
      setPaymentOption("plan:".concat(availablePlans[0].id));
      setSelectedPlan(availablePlans[0]);
    }
  }, [availablePlans.length]);
  useEffect(function () {
    var nextStep = computeNextStep();

    if (checkoutAvailable()) {
      nextStep();
    }
  }, []);

  var getRedirect = function getRedirect(po) {
    var activePurchaseQueryString = '';

    var _po$split = po.split(':'),
        _po$split2 = _slicedToArray(_po$split, 2),
        type = _po$split2[0],
        id = _po$split2[1];

    if (type === 'one-off' || type === 'login') {
      activePurchaseQueryString = "sessionId=".concat(session.id);
    } else {
      activePurchaseQueryString = "planId=".concat(id);
    }

    var redirectString = type === 'login' ? '' : encodeURIComponent('&') + 'checkout=true';
    var redirect = encodeURIComponent(window.location.origin + window.location.pathname) + '?' + activePurchaseQueryString + redirectString;
    return redirect;
  };

  var computeNextStep = function computeNextStep() {
    var search = new URLSearchParams(window.location.search);
    var sessionId = search.get('sessionId');
    var planId = search.get('planId');
    var callback = sessionId ? function () {
      return createSessionOrder({
        sessionId: session.id,
        startsAt: session.startsAt,
        endsAt: session.endsAt
      });
    } : function () {
      return createSubscriptionOrder(planId, [{
        resourceId: session.id,
        resourceType: AssetResourceType.SESSION
      }]);
    };
    return callback;
  };

  var subscribeAndBook = function subscribeAndBook() {
    var evt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    evt && evt.preventDefault();

    var _paymentOption$split = paymentOption.split(':'),
        _paymentOption$split2 = _slicedToArray(_paymentOption$split, 2),
        id = _paymentOption$split2[1];

    if (!currentUser) {
      doSignup(getRedirect(paymentOption)); // vetted with Bora on Aug 6

      return;
    }

    return createSubscriptionOrder(id, [{
      resourceId: session.id,
      resourceType: AssetResourceType.SESSION
    }]);
  };

  var bookNow = function bookNow(evt) {
    evt.preventDefault();
    setPaymentOption('one-off');

    if (!currentUser) {
      doSignup(getRedirect('one-off'));
      return;
    }

    return createSessionOrder({
      sessionId: session.id,
      startsAt: session.startsAt,
      endsAt: session.endsAt
    });
  };

  var planOptions = availablePlans.map(function (p, index) {
    var optionId = "plan:".concat(p.id);
    return {
      name: p.name,
      price: p.price,
      plan: p,
      optionId: optionId,
      checked: paymentOption === optionId,
      showSeparator: index !== (availablePlans === null || availablePlans === void 0 ? void 0 : availablePlans.length) - 1,
      onChange: handleOptionChange,
      setShowModal: setShowModal,
      setCurrentPlan: setSelectedPlan
    };
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Modal, {
      classes: "w-full md:w-10/12 lg:w-3/5",
      showCloseIcon: mobile,
      showModal: showModal,
      setModal: function setModal(_ref3) {
        var show = _ref3.show;
        return setShowModal(show);
      },
      children: /*#__PURE__*/_jsx(TWSubscriptionPlan, {
        plan: _objectSpread(_objectSpread({}, selectedPlan), {}, {
          invoicePreview: null
        }),
        type: !desktop || !iPad ? TWSubscriptionPlanCardType.SKINNY : TWSubscriptionPlanCardType.FULL_WIDTH,
        onSelect: function onSelect() {
          return subscribeAndBook();
        },
        ctaText: "Subscribe & Book",
        noShadow: true
      })
    }), (planOptions === null || planOptions === void 0 ? void 0 : planOptions.length) > 0 && /*#__PURE__*/_jsxs("div", {
      className: "mt-8 md:mt-0",
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-base font-medium",
        children: "Book for free when you subscribe:"
      }), /*#__PURE__*/_jsxs("div", {
        className: "box-shadow rounded-lg py-6 px-4",
        children: [planOptions.map(function (po) {
          return /*#__PURE__*/_createElement(PlanOptionItem, _objectSpread(_objectSpread({}, po), {}, {
            key: po.optionId
          }));
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-6 mb-0",
          children: /*#__PURE__*/_jsx(Button, {
            text: "Subscribe & Book",
            size: "lg",
            disabled: false,
            onClick: subscribeAndBook
          })
        })]
      })]
    }), session.price.unitAmount > 0 && /*#__PURE__*/_jsxs("div", {
      className: "mt-8 box-shadow bg-white py-6 px-4 md:rounded-lg",
      "data-cy": "individual-session",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex justify-between",
        children: [/*#__PURE__*/_jsx("p", {
          className: "m-0 bold",
          children: "Individual Session"
        }), /*#__PURE__*/_jsx("p", {
          className: "m-0",
          children: getPriceStringInterval(session.price)
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4 mb-0",
        children: /*#__PURE__*/_jsx(Button, {
          text: "Book Now",
          size: "lg",
          disabled: false,
          type: "secondary",
          onClick: bookNow,
          "data-cy": "book-now"
        })
      })]
    }), !currentUser && /*#__PURE__*/_jsxs("div", {
      className: "text-center my-6 px-4",
      children: ["Already a subscriber?", ' ', /*#__PURE__*/_jsx("span", {
        className: "font-medium text-subkit-primary cursor-pointer",
        onClick: function onClick() {
          return doSignup(getRedirect('login'));
        },
        children: "Log in to book"
      })]
    })]
  });
};